import { render, staticRenderFns } from "./ChangeLogPreview.modal.vue?vue&type=template&id=77fb280b"
import script from "./ChangeLogPreview.modal.vue?vue&type=script&lang=ts"
export * from "./ChangeLogPreview.modal.vue?vue&type=script&lang=ts"
import style0 from "./ChangeLogPreview.modal.vue?vue&type=style&index=0&id=77fb280b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports